import { css } from 'aphrodite';
import React, { FC } from 'react';
import { buttonStyle, style } from './style';

interface Props {
  label: string;
  languages: ILanguage[];
  selectedLanguage: ILanguage;
  onLanguageSelectedCallback: (language: ILanguage) => any;
}

export interface ILanguage {
  id: string;
  label: string;
  active: string;
  voiceover_badge_text: string;
  video_url_identifier: string;
  video_id_identifier: string;
  video_speaker_bio_urls_identifier: string;
}

export const LanguageSelector: FC<Props> = ({ label, languages, selectedLanguage, onLanguageSelectedCallback }) => {
  const styles = style();

  const getLanguagesButtons = (): JSX.Element[] => {
    return languages.map((language: ILanguage, index: number) => {
      const buttonStyles = buttonStyle(language.id === selectedLanguage.id);
      return (
        <span
          key={index}
          className={css(styles.text, buttonStyles.button)}
          onClick={() => onLanguageSelected(language)}>
          {language.label}
        </span>
      );
    });
  };

  const onLanguageSelected = (language: ILanguage): void => {
    onLanguageSelectedCallback(language);
  };

  return (
    <div className={css(styles.container)}>
      <span className={css(styles.text, styles.label)}>{label}</span>
      <div className={css(styles.languageButtons)}>{getLanguagesButtons()}</div>
    </div>
  );
};
